'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var EventEmitter = require('eventemitter3');
var isUndefined = require('lodash/isUndefined');
var omitBy = require('lodash/omitBy');
var clone = require('lodash/clone');
var trimEnd = require('lodash/trimEnd');
var trimStart = require('lodash/trimStart');
var isEmpty = require('lodash/isEmpty');
var isDate = require('lodash/isDate');
var isPlainObject = require('lodash/isPlainObject');
var mapValues = require('lodash/mapValues');
var omit = require('lodash/omit');
var castArray = require('lodash/castArray');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var EventEmitter__default = /*#__PURE__*/_interopDefaultLegacy(EventEmitter);
var isUndefined__default = /*#__PURE__*/_interopDefaultLegacy(isUndefined);
var omitBy__default = /*#__PURE__*/_interopDefaultLegacy(omitBy);
var clone__default = /*#__PURE__*/_interopDefaultLegacy(clone);
var trimEnd__default = /*#__PURE__*/_interopDefaultLegacy(trimEnd);
var trimStart__default = /*#__PURE__*/_interopDefaultLegacy(trimStart);
var isEmpty__default = /*#__PURE__*/_interopDefaultLegacy(isEmpty);
var isDate__default = /*#__PURE__*/_interopDefaultLegacy(isDate);
var isPlainObject__default = /*#__PURE__*/_interopDefaultLegacy(isPlainObject);
var mapValues__default = /*#__PURE__*/_interopDefaultLegacy(mapValues);
var omit__default = /*#__PURE__*/_interopDefaultLegacy(omit);
var castArray__default = /*#__PURE__*/_interopDefaultLegacy(castArray);

const event = new EventEmitter__default["default"]();

const adapters = {};
function setAdapters(newAdapters) {
    Object.assign(adapters, newAdapters);
    event.emit('adapters:set', newAdapters, adapters);
}
function getAdapter(name) {
    return adapters[name];
}
function mustGetAdapter(name) {
    if (name in adapters) {
        return adapters[name];
    }
    throw new Error(`未设置 adapter ${name}`);
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

var LogLevel;
(function (LogLevel) {
    LogLevel["TRACE"] = "TRACE";
    LogLevel["INFO"] = "INFO";
    LogLevel["ERROR"] = "ERROR";
})(LogLevel || (LogLevel = {}));
const log = {
    trace: (label, data) => event.emit('log', { level: LogLevel.TRACE, label, data }),
    info: (label, data) => event.emit('log', { level: LogLevel.INFO, label, data }),
    error: (label, data) => event.emit('log', { level: LogLevel.ERROR, label, data }),
};

function encodeQuery(query) {
    let str = '';
    Object.entries(query).forEach(([key, value], index) => {
        if (value === undefined) {
            return;
        }
        if (typeof value !== 'string') {
            value = JSON.stringify(value);
        }
        if (index) {
            str += '&';
        }
        str += key + '=' + encodeURIComponent(value);
    });
    return str;
}
function encodeURL(base, query) {
    if (query) {
        const queryString = encodeQuery(query);
        if (queryString) {
            return base + '?' + queryString;
        }
    }
    return base;
}
function convertResponse(res) {
    return {
        status: res.status || 200,
        header: res.headers,
        body: res.data,
    };
}
let nextId = 1;
function request(request, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const doRequest = mustGetAdapter('request');
        const id = nextId++;
        log.trace('http:send', { id, request });
        const url = encodeURL(request.url, request.query);
        const response = yield doRequest(url, {
            method: request.method,
            headers: omitBy__default["default"](request.header, isUndefined__default["default"]),
            data: request.body,
            signal: options === null || options === void 0 ? void 0 : options.abortSignal,
            onprogress: options === null || options === void 0 ? void 0 : options.onProgress,
        }).then(convertResponse);
        log.trace('http:recv', { id, response });
        return response;
    });
}
function upload(request, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const upload = mustGetAdapter('upload');
        const url = encodeURL(request.url, request.query);
        const id = nextId++;
        log.trace('upload:send', { id, request });
        const response = yield upload(url, request.file, {
            method: request.method,
            headers: request.header,
            data: request.form,
            signal: options === null || options === void 0 ? void 0 : options.abortSignal,
            onprogress: options === null || options === void 0 ? void 0 : options.onProgress,
        }).then(convertResponse);
        log.trace('upload:recv', { id, response });
        return response;
    });
}

class Runtime {
    constructor() {
        this.adapters = adapters;
        this.event = event;
        this.http = { request, upload };
        this.log = log;
        this.modules = {};
        this.getAdapter = mustGetAdapter;
    }
}
const runtime = new Runtime();
function use(module) {
    var _a;
    const { name } = module;
    if (name in runtime.modules) {
        throw new Error(`已导入名为 ${name} 的模块`);
    }
    runtime.modules[name] = module;
    log.trace('module:load', module);
    event.emit('module:load', module);
    (_a = module.onLoad) === null || _a === void 0 ? void 0 : _a.call(module, runtime);
}

class APIError extends Error {
    constructor(code, error) {
        super(`code: ${code}, error: ${error}`);
        this.code = code;
        this.error = error;
    }
}

const KEY_SERVER_URLS = 'server_urls';
function isCNApp(app) {
    return app.appId.slice(-9) !== '-MdYXbMMI';
}
class AppRouter {
    constructor(app) {
        this.app = app;
        this._refreshing = false;
    }
    getDefaultServerURLs(ttl = 0) {
        const domain = isCNApp(this.app) ? 'lncld.net' : 'lncldglobal.com';
        const id = this.app.appId.slice(0, 8).toLowerCase();
        return {
            stats_server: `${id}.stats.${domain}`,
            rtm_router_server: `${id}.rtm.${domain}`,
            push_server: `${id}.push.${domain}`,
            play_server: `${id}.play.${domain}`,
            engine_server: `${id}.engine.${domain}`,
            api_server: `${id}.api.${domain}`,
            ttl: 0,
            expire_at: Date.now() + ttl * 1000,
        };
    }
    getServerURLs() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._urls) {
                const urls = yield this.app.localStorage.getAsync(KEY_SERVER_URLS);
                if (urls) {
                    this._urls = JSON.parse(urls);
                }
                else {
                    this._urls = this.getDefaultServerURLs();
                }
            }
            if (Date.now() >= this._urls.expire_at) {
                this.refresh();
            }
            return this._urls;
        });
    }
    refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._refreshing) {
                return;
            }
            this._refreshing = true;
            try {
                const { body: urls } = yield request({
                    method: 'GET',
                    url: 'https://app-router.com/2/route',
                    query: {
                        appId: this.app.appId,
                    },
                });
                this._urls = Object.assign(Object.assign({}, urls), { expire_at: Date.now() + urls.ttl * 1000 });
                yield this.app.localStorage.setAsync(KEY_SERVER_URLS, JSON.stringify(this._urls));
            }
            finally {
                this._refreshing = false;
            }
        });
    }
    getServiceURL(service, schema = 'https') {
        return __awaiter(this, void 0, void 0, function* () {
            const urls = yield this.getServerURLs();
            switch (service) {
                case 'api':
                    return `${schema}://${urls.api_server}`;
                case 'engine':
                    return `${schema}://${urls.engine_server}`;
                case 'push':
                    return `${schema}://${urls.push_server}`;
                default:
                    throw new Error('Unknown app router service: ' + service);
            }
        });
    }
}

class GeoPoint {
    constructor(point, longitude) {
        if (typeof point === 'number') {
            this.latitude = point;
            this.longitude = longitude;
        }
        else {
            this.latitude = point.latitude;
            this.longitude = point.longitude;
        }
        if (typeof this.latitude !== 'number') {
            throw new Error('The latitude must be a number');
        }
        if (typeof this.longitude !== 'number') {
            throw new Error('The longitude must be a number');
        }
    }
    toJSON() {
        return this._LC_encode();
    }
    _LC_encode() {
        return {
            __type: 'GeoPoint',
            latitude: this.latitude,
            longitude: this.longitude,
        };
    }
}

const ACL_ACTIONS = ['read', 'write'];
class ACL {
    constructor() {
        this._privileges = {};
        ACL_ACTIONS.forEach((action) => (this._privileges[action] = new Set()));
    }
    static fromJSON(data) {
        const acl = new ACL();
        Object.entries(data).forEach(([subject, privilege]) => {
            Object.entries(privilege).forEach(([action, allowed]) => {
                if (allowed) {
                    acl.allow(subject, action);
                }
            });
        });
        return acl;
    }
    static getSubjectKey(subject) {
        if (typeof subject === 'string') {
            return subject;
        }
        if ('aclKey' in subject) {
            return subject.aclKey;
        }
        if ('id' in subject) {
            return subject.id;
        }
        throw new TypeError('Invalid ACL Subject');
    }
    allow(subject, action, ...actions) {
        actions.concat(action).forEach((action) => {
            this._privileges[action].add(ACL.getSubjectKey(subject));
        });
        return this;
    }
    disallow(subject, action, ...actions) {
        actions.concat(action).forEach((action) => {
            this._privileges[action].delete(ACL.getSubjectKey(subject));
        });
        return this;
    }
    can(subject, action) {
        return this._privileges[action].has(ACL.getSubjectKey(subject));
    }
    toJSON() {
        const json = {};
        Object.entries(this._privileges).forEach(([action, subjects]) => {
            subjects.forEach((subject) => {
                if (!json[subject]) {
                    json[subject] = {};
                }
                json[subject][action] = true;
            });
        });
        return json;
    }
    _LC_getData() {
        return this.toJSON();
    }
    _LC_encode() {
        return this.toJSON();
    }
}

const RESERVED_KEYS = ['className', 'objectId', 'createdAt', 'updatedAt'];
function omitReservedKeys(data) {
    return omit__default["default"](data, RESERVED_KEYS);
}
function assertCanIgnoreHooks(app, options) {
    if (!app.config.hookKey) {
        if (!app.config.masterKey) {
            throw new Error('Cannot ignore hooks when both hookKey and masterKey is not set');
        }
        if ((options === null || options === void 0 ? void 0 : options.useMasterKey) === false || (!(options === null || options === void 0 ? void 0 : options.useMasterKey) && !app.config.useMasterKey)) {
            throw new Error('Cannot ignore hooks when useMasterKey is false');
        }
    }
}
class LCObjectReference {
    constructor(app, className, id, _decoder) {
        this.app = app;
        this.className = className;
        this.id = id;
        this._decoder = _decoder;
    }
    get(options) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const rawData = yield this.app.request({
                method: 'GET',
                path: `/1.1/classes/${this.className}/${this.id}`,
                query: {
                    keys: (_a = options === null || options === void 0 ? void 0 : options.keys) === null || _a === void 0 ? void 0 : _a.join(','),
                    include: (_b = options === null || options === void 0 ? void 0 : options.include) === null || _b === void 0 ? void 0 : _b.join(','),
                    returnACL: options === null || options === void 0 ? void 0 : options.returnACL,
                },
            }, options);
            if (isEmpty__default["default"](rawData)) {
                throw new Error(`不存在 objectId 为 ${this.id} 的对象`);
            }
            return this._decoder(this.app, rawData, this.className);
        });
    }
    update(data, options) {
        return __awaiter(this, void 0, void 0, function* () {
            if ((options === null || options === void 0 ? void 0 : options.ignoreBeforeHook) || (options === null || options === void 0 ? void 0 : options.ignoreAfterHook)) {
                assertCanIgnoreHooks(this.app, options);
            }
            const rawData = yield this.app.request(makeUpdateObjectRequest(this.className, this.id, data, options), options);
            return this._decoder(this.app, rawData, this.className);
        });
    }
    delete(options) {
        return __awaiter(this, void 0, void 0, function* () {
            if ((options === null || options === void 0 ? void 0 : options.ignoreBeforeHook) || (options === null || options === void 0 ? void 0 : options.ignoreAfterHook)) {
                assertCanIgnoreHooks(this.app, options);
            }
            yield this.app.request(makeDeleteObjectRequest(this.className, this.id, options), options);
        });
    }
    toJSON() {
        return this._LC_encode();
    }
    _LC_encode() {
        return {
            __type: 'Pointer',
            className: this.className,
            objectId: this.id,
        };
    }
}
class LCObject {
    constructor(arg1, className, id) {
        this.data = {};
        this._rawData = {};
        if (className && id) {
            this._ref = new LCObjectReference(arg1, className, id, LCObject.fromJSON);
        }
        else {
            this._ref = arg1;
        }
    }
    get app() {
        return this._ref.app;
    }
    get className() {
        return this._ref.className;
    }
    get id() {
        return this._ref.id;
    }
    get createdAt() {
        return this.data.createdAt;
    }
    get updatedAt() {
        return this.data.updatedAt;
    }
    static fromJSON(app, data, className = data.className) {
        const objectId = data.objectId;
        if (!className || !objectId) {
            throw new Error('Cannot create LCObject from json: the className or objectId must be provided');
        }
        const object = new LCObject(app, className, objectId);
        object._rawData = data;
        object.data = LCDecode(app, omit__default["default"](data, ['__type', 'className']));
        if (data.ACL) {
            object.data.ACL = ACL.fromJSON(data.ACL);
        }
        if (data.createdAt) {
            object.data.createdAt = new Date(data.createdAt);
        }
        if (data.updatedAt) {
            object.data.updatedAt = new Date(data.updatedAt);
        }
        return object;
    }
    _LC_encode(options) {
        if (options === null || options === void 0 ? void 0 : options.preferPointer) {
            return this._ref.toJSON();
        }
        return Object.assign(Object.assign({}, this._rawData), { __type: 'Object', className: this.className, objectId: this.id });
    }
    _LC_getData() {
        return getLCObjectData(this.data);
    }
    toJSON() {
        return this._LC_getData();
    }
    get(options) {
        return this._ref.get(options);
    }
    update(data, options) {
        return this._ref.update(data, options);
    }
    delete(options) {
        return this._ref.delete(options);
    }
}
function getLCObjectData(data) {
    if (data) {
        if (typeof data._LC_getData === 'function') {
            return data._LC_getData();
        }
        if (Array.isArray(data)) {
            return data.map((value) => getLCObjectData(value));
        }
        if (isPlainObject__default["default"](data)) {
            return mapValues__default["default"](data, (value) => getLCObjectData(value));
        }
    }
    return data;
}
function LCEncode(data, options) {
    if (!data) {
        return data;
    }
    if (data._LC_encode) {
        if (typeof data._LC_encode === 'function') {
            return data._LC_encode(options);
        }
        return LCEncode(data._LC_encode, options);
    }
    if (isDate__default["default"](data)) {
        return { __type: 'Date', iso: data.toISOString() };
    }
    if (Array.isArray(data)) {
        return data.map((value) => LCEncode(value, options));
    }
    if (isPlainObject__default["default"](data)) {
        return mapValues__default["default"](data, (value) => LCEncode(value, options));
    }
    return data;
}
function encodeObjectData(data) {
    return LCEncode(omitReservedKeys(data), { preferPointer: true });
}
function LCDecode(app, data) {
    var _a;
    if (!data) {
        return data;
    }
    if (isPlainObject__default["default"](data)) {
        switch (data.__type) {
            case 'Pointer':
            case 'Object':
                return LCObject.fromJSON(app, data);
            case 'File':
                (_a = data.objectId) !== null && _a !== void 0 ? _a : (data.objectId = data.id);
                return LCObject.fromJSON(app, data, '_File');
            case 'Date':
                return new Date(data.iso);
            case 'GeoPoint':
                return new GeoPoint(data);
            default:
                return mapValues__default["default"](data, (value) => LCDecode(app, value));
        }
    }
    if (Array.isArray(data)) {
        return data.map((value) => LCDecode(app, value));
    }
    return data;
}
function isLCObject(value) {
    return value && (value instanceof LCObject || value._isLCObject === true);
}
function isLCObjectRef(value) {
    return (isLCObject(value) ||
        (value && (value instanceof LCObjectReference || value._isLCObjectRef === true)));
}
function makeUpdateObjectRequest(className, objectId, data, options) {
    var _a;
    const body = encodeObjectData(data);
    if ((options === null || options === void 0 ? void 0 : options.ignoreBeforeHook) || (options === null || options === void 0 ? void 0 : options.ignoreAfterHook)) {
        body.__ignore_hooks = [];
        if (options.ignoreBeforeHook) {
            body.__ignore_hooks.push('beforeUpdate');
        }
        if (options.ignoreAfterHook) {
            body.__ignore_hooks.push('afterUpdate');
        }
    }
    return {
        method: 'PUT',
        path: `/1.1/classes/${className}/${objectId}`,
        query: {
            fetchWhenSave: options === null || options === void 0 ? void 0 : options.fetchUpdatedData,
            where: (_a = options === null || options === void 0 ? void 0 : options.query) === null || _a === void 0 ? void 0 : _a.params.where,
        },
        body,
    };
}
function makeDeleteObjectRequest(className, objectId, options) {
    let body;
    if ((options === null || options === void 0 ? void 0 : options.ignoreBeforeHook) || (options === null || options === void 0 ? void 0 : options.ignoreAfterHook)) {
        body = { __ignore_hooks: [] };
        if (options === null || options === void 0 ? void 0 : options.ignoreBeforeHook) {
            body.__ignore_hooks.push('beforeDelete');
        }
        if (options === null || options === void 0 ? void 0 : options.ignoreAfterHook) {
            body.__ignore_hooks.push('afterDelete');
        }
    }
    return {
        method: 'DELETE',
        path: `/1.1/classes/${className}/${objectId}`,
        body,
    };
}

function isAndCondition(cond) {
    return cond && '$and' in cond;
}
function isOrCondition(cond) {
    return cond && '$or' in cond;
}
function isPureOrCondition(cond) {
    return isOrCondition(cond) && Object.keys(cond).length === 1;
}
function isConstraint(value) {
    return value && typeof value.applyQueryConstraint === 'function';
}
function encode(value) {
    return LCEncode(value, { preferPointer: true });
}
class EqualConstraint {
    constructor(value) {
        this.value = value;
    }
    applyQueryConstraint(cond, key) {
        return Object.assign(Object.assign({}, cond), { [key]: encode(this.value) });
    }
}
class NotEqualConstraint {
    constructor(value) {
        this.value = value;
    }
    applyQueryConstraint(cond, key) {
        return Object.assign(Object.assign({}, cond), { [key]: Object.assign(Object.assign({}, cond[key]), { $ne: encode(this.value) }) });
    }
}
class GreaterThanConstraint {
    constructor(value) {
        this.value = value;
    }
    applyQueryConstraint(cond, key) {
        return Object.assign(Object.assign({}, cond), { [key]: Object.assign(Object.assign({}, cond[key]), { $gt: encode(this.value) }) });
    }
}
class GreaterThanOrEqualConstraint {
    constructor(value) {
        this.value = value;
    }
    applyQueryConstraint(cond, key) {
        return Object.assign(Object.assign({}, cond), { [key]: Object.assign(Object.assign({}, cond[key]), { $gte: encode(this.value) }) });
    }
}
class LessThanConstraint {
    constructor(value) {
        this.value = value;
    }
    applyQueryConstraint(cond, key) {
        return Object.assign(Object.assign({}, cond), { [key]: Object.assign(Object.assign({}, cond[key]), { $lt: encode(this.value) }) });
    }
}
class LessThanOrEqualConstraint {
    constructor(value) {
        this.value = value;
    }
    applyQueryConstraint(cond, key) {
        return Object.assign(Object.assign({}, cond), { [key]: Object.assign(Object.assign({}, cond[key]), { $lte: encode(this.value) }) });
    }
}
class ExistsConstraint {
    applyQueryConstraint(cond, key) {
        return Object.assign(Object.assign({}, cond), { [key]: Object.assign(Object.assign({}, cond[key]), { $exists: true }) });
    }
}
class NotExistsConstraint {
    applyQueryConstraint(cond, key) {
        return Object.assign(Object.assign({}, cond), { [key]: Object.assign(Object.assign({}, cond[key]), { $exists: false }) });
    }
}
class SizeEqualConstraint {
    constructor(size) {
        this.size = size;
    }
    applyQueryConstraint(cond, key) {
        return Object.assign(Object.assign({}, cond), { [key]: Object.assign(Object.assign({}, cond[key]), { $size: this.size }) });
    }
}
class MatchesKeyConstraint {
    constructor(className, key, condition) {
        this.className = className;
        this.key = key;
        this.condition = condition;
    }
    applyQueryConstraint(cond, key) {
        return Object.assign(Object.assign({}, cond), { [key]: Object.assign(Object.assign({}, cond[key]), { $select: {
                    key: this.key,
                    query: {
                        className: this.className,
                        where: this.condition,
                    },
                } }) });
    }
}
class NotMatchesKeyConstraint {
    constructor(className, key, condition) {
        this.className = className;
        this.key = key;
        this.condition = condition;
    }
    applyQueryConstraint(cond, key) {
        return Object.assign(Object.assign({}, cond), { [key]: Object.assign(Object.assign({}, cond[key]), { $dontSelect: {
                    key: this.key,
                    query: {
                        className: this.className,
                        where: this.condition,
                    },
                } }) });
    }
}
class MatchesQueryConstraint {
    constructor(className, condition) {
        this.className = className;
        this.condition = condition;
    }
    applyQueryConstraint(cond, key) {
        return Object.assign(Object.assign({}, cond), { [key]: Object.assign(Object.assign({}, cond[key]), { $inQuery: {
                    className: this.className,
                    where: this.condition,
                } }) });
    }
}
class NotMatchesQueryConstraint {
    constructor(className, condition) {
        this.className = className;
        this.condition = condition;
    }
    applyQueryConstraint(cond, key) {
        return Object.assign(Object.assign({}, cond), { [key]: Object.assign(Object.assign({}, cond[key]), { $notInQuery: {
                    className: this.className,
                    where: this.condition,
                } }) });
    }
}
class MatchesConstraint {
    constructor(regexp) {
        this._flags = '';
        if (typeof regexp === 'string') {
            this._regexp = regexp;
        }
        else {
            this._regexp = regexp.source;
            if (regexp.ignoreCase) {
                this._flags += 'i';
            }
            if (regexp.multiline) {
                this._flags += 'm';
            }
            if (regexp.ignoreBlank) {
                this._flags += 'x';
            }
            if (regexp.dotAll) {
                this._flags += 's';
            }
        }
    }
    applyQueryConstraint(cond, key) {
        return Object.assign(Object.assign({}, cond), { [key]: Object.assign(Object.assign({}, cond[key]), { $regex: this._regexp, $options: this._flags || undefined }) });
    }
}
class InConstraint {
    constructor(value) {
        this.value = value;
    }
    applyQueryConstraint(cond, key) {
        return Object.assign(Object.assign({}, cond), { [key]: Object.assign(Object.assign({}, cond[key]), { $in: encode(this.value) }) });
    }
}
class NotInConstraint {
    constructor(value) {
        this.value = value;
    }
    applyQueryConstraint(cond, key) {
        return Object.assign(Object.assign({}, cond), { [key]: Object.assign(Object.assign({}, cond[key]), { $nin: encode(this.value) }) });
    }
}
class ContainsAllConstraint {
    constructor(value) {
        this._value = encode(value);
    }
    applyQueryConstraint(cond, key) {
        return Object.assign(Object.assign({}, cond), { [key]: Object.assign(Object.assign({}, cond[key]), { $all: this._value }) });
    }
}
class OrConstraint {
    constructor(value) {
        this.value = value;
    }
    applyQueryConstraint(cond, key) {
        if (this.value.length === 0) {
            return cond;
        }
        const or = [];
        this.value.forEach((item) => {
            if (!isConstraint(item)) {
                item = new EqualConstraint(item);
            }
            or.push(item.applyQueryConstraint({}, key));
        });
        if (isPureOrCondition(cond)) {
            return Object.assign(Object.assign({}, cond), { $or: cond.$or.concat(or) });
        }
        const newCond = or.length === 1 ? or[0] : { $or: or };
        if (isEmpty__default["default"](cond)) {
            return newCond;
        }
        if (isAndCondition(cond)) {
            return Object.assign(Object.assign({}, cond), { $and: cond.$and.concat(newCond) });
        }
        return { $and: [cond, newCond] };
    }
}
class AndConstraint {
    constructor(value) {
        this.value = value;
    }
    applyQueryConstraint(cond, key) {
        if (this.value.length === 0) {
            return cond;
        }
        const and = [];
        this.value.forEach((item) => {
            if (!isConstraint(item)) {
                item = new EqualConstraint(item);
            }
            and.push(item.applyQueryConstraint({}, key));
        });
        const newCond = and.length === 1 ? and[0] : { $and: and };
        if (isEmpty__default["default"](cond)) {
            return newCond;
        }
        if (isAndCondition(cond)) {
            return Object.assign(Object.assign({}, cond), { $and: [...cond.$and, newCond] });
        }
        return { $and: [cond, newCond] };
    }
}

function eq(value) {
    if (value === undefined) {
        return undefined;
    }
    return new EqualConstraint(value);
}
function ne(value) {
    if (value === undefined) {
        return undefined;
    }
    return new NotEqualConstraint(value);
}
function gt(value) {
    if (value === undefined) {
        return undefined;
    }
    return new GreaterThanConstraint(value);
}
function gte(value) {
    if (value === undefined) {
        return undefined;
    }
    return new GreaterThanOrEqualConstraint(value);
}
function lt(value) {
    if (value === undefined) {
        return undefined;
    }
    return new LessThanConstraint(value);
}
function lte(value) {
    if (value === undefined) {
        return undefined;
    }
    return new LessThanOrEqualConstraint(value);
}
function exists() {
    return new ExistsConstraint();
}
function notExists() {
    return new NotExistsConstraint();
}
function sizeIs(size) {
    if (size === undefined) {
        return undefined;
    }
    return new SizeEqualConstraint(size);
}
function _in(value) {
    if (value === undefined) {
        return undefined;
    }
    if (Array.isArray(value)) {
        return new InConstraint(value);
    }
    const { className, params } = value;
    const keys = params.keys;
    if (keys) {
        if (keys.includes(',')) {
            throw new Error('使用子查询时，只能包含一个 key');
        }
        return new MatchesKeyConstraint(className, keys, params.where);
    }
    return new MatchesQueryConstraint(className, params.where);
}
function notIn(value) {
    if (value === undefined) {
        return undefined;
    }
    if (Array.isArray(value)) {
        return new NotInConstraint(value);
    }
    const { className, params } = value;
    const keys = params.keys;
    if (keys) {
        if (keys.includes(',')) {
            throw new Error('使用子查询时，只能包含一个 key');
        }
        return new NotMatchesKeyConstraint(className, keys, params.where);
    }
    return new NotMatchesQueryConstraint(className, params.where);
}
function matches(regexp) {
    if (regexp === undefined) {
        return undefined;
    }
    return new MatchesConstraint(regexp);
}
function quote(s) {
    return '\\Q' + s.replace('\\E', '\\E\\\\E\\Q') + '\\E';
}
function contains(s) {
    if (s === undefined) {
        return undefined;
    }
    return matches(quote(s));
}
function startsWith(s) {
    if (s === undefined) {
        return undefined;
    }
    return matches('^' + quote(s));
}
function endsWith(s) {
    if (s === undefined) {
        return undefined;
    }
    return matches(quote(s) + '$');
}
function containsAll(values) {
    if (values === undefined) {
        return undefined;
    }
    return new ContainsAllConstraint(values);
}
function or(...args) {
    if (args.length === 0) {
        return undefined;
    }
    return new OrConstraint(args);
}
function and(...args) {
    if (args.length === 0) {
        return undefined;
    }
    return new AndConstraint(args);
}
const queryCommand = {
    eq,
    '==': eq,
    ne,
    '!=': ne,
    gt,
    '>': gt,
    gte,
    '>=': gte,
    lt,
    '<': lt,
    lte,
    '<=': lte,
    exists,
    notExists,
    'not-exists': notExists,
    sizeIs,
    'size-is': sizeIs,
    in: _in,
    notIn,
    'not-in': notIn,
    matches,
    contains,
    startsWith,
    'starts-with': startsWith,
    endsWith,
    'ends-with': endsWith,
    containsAll,
    'contains-all': containsAll,
    or,
    and,
};

class Query {
    constructor(app, className, _decoder) {
        this.app = app;
        this.className = className;
        this._decoder = _decoder;
        this._order = new Set();
        this._include = new Set();
        this._keys = new Set();
        this._condition = {};
    }
    get params() {
        const params = {};
        if (this._order.size) {
            params.order = Array.from(this._order).join(',');
        }
        if (this._include.size) {
            params.include = Array.from(this._include).join(',');
        }
        if (this._keys.size) {
            params.keys = Array.from(this._keys).join(',');
        }
        if (this._returnACL) {
            params.returnACL = true;
        }
        if (!isEmpty__default["default"](this._condition)) {
            params.where = this._condition;
        }
        if (this._skip !== undefined) {
            params.skip = this._skip;
        }
        if (this._limit !== undefined) {
            params.limit = this._limit;
        }
        return params;
    }
    _applyConstraint(cond) {
        if (!isPlainObject__default["default"](cond)) {
            throw new Error('无效的查询约束');
        }
        let tempCond = this._condition;
        Object.entries(cond).forEach(([key, value]) => {
            if (value === undefined) {
                return;
            }
            if (!isConstraint(value)) {
                value = queryCommand.eq(value);
            }
            tempCond = value.applyQueryConstraint(tempCond, key);
        });
        return tempCond;
    }
    clone() {
        const query = new Query(this.app, this.className, this._decoder);
        query._order = new Set(this._order);
        query._include = new Set(this._include);
        query._keys = new Set(this._keys);
        query._condition = this._condition;
        query._skip = this._skip;
        query._limit = this._limit;
        query._returnACL = this._returnACL;
        return query;
    }
    where(cond, command, ...values) {
        const query = this.clone();
        if (typeof cond === 'string') {
            if (!command) {
                throw new TypeError('查询命令不能为空');
            }
            if (!queryCommand[command]) {
                throw new TypeError(`未知的查询命令 ${command}`);
            }
            return query.where({ [cond]: queryCommand[command](...values) });
        }
        if (isEmpty__default["default"](cond)) {
            return query;
        }
        if (Array.isArray(cond)) {
            const or = [];
            cond.forEach((item) => {
                const tempCond = query._applyConstraint(item);
                if (!isEmpty__default["default"](tempCond)) {
                    or.push(tempCond);
                }
            });
            if (or.length) {
                query._condition = or.length === 1 ? or[0] : { $or: or };
            }
        }
        else {
            query._condition = query._applyConstraint(cond);
        }
        return query;
    }
    select(key, ...rest) {
        const query = this.clone();
        rest.concat(key).forEach((k) => query._keys.add(k));
        return query;
    }
    include(key, ...rest) {
        const query = this.clone();
        rest.concat(key).forEach((k) => query._include.add(k));
        return query;
    }
    skip(count) {
        const query = this.clone();
        query._skip = count;
        return query;
    }
    limit(count) {
        const query = this.clone();
        query._limit = count;
        return query;
    }
    orderBy(key, order = 'asc') {
        const query = this.clone();
        switch (order) {
            case 'asc':
                query._order.add(key).delete('-' + key);
                break;
            case 'desc':
                query._order.add('-' + key).delete(key);
                break;
            default:
                throw new TypeError(`未知的查询排序方式 ${order}`);
        }
        return query;
    }
    returnACL(enable) {
        const query = this.clone();
        query._returnACL = enable;
        return query;
    }
    decodeObject(data) {
        return this._decoder(this.app, data, this.className);
    }
    find(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { results = [] } = (yield this.app.request({
                method: 'GET',
                path: `/1.1/classes/${this.className}`,
                query: this.params,
            }, options));
            return results.map((result) => this._decoder(this.app, result, this.className));
        });
    }
    first(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const objects = yield this.limit(1).find(options);
            return objects.length ? objects[0] : null;
        });
    }
    count(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { count = 0 } = (yield this.app.request({
                method: 'GET',
                path: `/1.1/classes/${this.className}`,
                query: Object.assign(Object.assign({}, this.params), { limit: 0, count: 1 }),
            }, options));
            return count;
        });
    }
    findAndCount(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { count, results } = (yield this.app.request({
                method: 'GET',
                path: `/1.1/classes/${this.className}`,
                query: Object.assign(Object.assign({}, this.params), { count: 1 }),
            }, options));
            return [results.map((data) => this.decodeObject(data)), count];
        });
    }
    scan(options) {
        return new QueryIterator(this, options);
    }
    [Symbol.asyncIterator]() {
        return this.scan();
    }
}
class QueryIterator {
    constructor(query, options) {
        this._app = query.app;
        this._className = query.className;
        this._query = query;
        this._options = Object.assign(Object.assign({}, options), { useMasterKey: true });
        const { limit, where } = query.params;
        this._limit = limit;
        this._condition = where;
    }
    next() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._cursor === null) {
                return { value: [], done: true };
            }
            const { results = [], cursor: cursor = null } = (yield this._app.request({
                method: 'GET',
                path: `/1.1/scan/classes/${this._className}`,
                query: {
                    cursor: this._cursor,
                    limit: this._limit,
                    where: this._condition,
                },
            }, this._options));
            this._cursor = cursor;
            return {
                value: results.map((data) => this._query.decodeObject(data)),
                done: cursor === null && results.length === 0,
            };
        });
    }
}

function makeAddObjectRequest(className, data, options) {
    const body = encodeObjectData(data);
    if ((options === null || options === void 0 ? void 0 : options.ignoreBeforeHook) || (options === null || options === void 0 ? void 0 : options.ignoreAfterHook)) {
        body.__ignore_hooks = [];
        if (options.ignoreBeforeHook) {
            body.__ignore_hooks.push('beforeSave');
        }
        if (options.ignoreAfterHook) {
            body.__ignore_hooks.push('afterSave');
        }
    }
    return {
        method: 'POST',
        path: '/1.1/classes/' + className,
        query: {
            fetchWhenSave: options === null || options === void 0 ? void 0 : options.fetchData,
        },
        body,
    };
}
class Class extends Query {
    object(id) {
        return new LCObjectReference(this.app, this.className, id, this._decoder);
    }
    add(data, options) {
        return __awaiter(this, void 0, void 0, function* () {
            if ((options === null || options === void 0 ? void 0 : options.ignoreBeforeHook) || (options === null || options === void 0 ? void 0 : options.ignoreAfterHook)) {
                assertCanIgnoreHooks(this.app, options);
            }
            const rawData = yield this.app.request(makeAddObjectRequest(this.className, data, options), options);
            return this._decoder(this.app, rawData, this.className);
        });
    }
}

function unset() {
    return { __op: 'Delete' };
}
function increment(amount = 1) {
    return { __op: 'Increment', amount };
}
function decrement(amount = 1) {
    return { __op: 'Decrement', amount };
}
function add(objects) {
    return { __op: 'Add', objects: castArray__default["default"](objects) };
}
function addUnique(objects) {
    return { __op: 'AddUnique', objects: castArray__default["default"](objects) };
}
function remove(objects) {
    return { __op: 'Remove', objects: castArray__default["default"](objects) };
}
function bitAnd(value) {
    return { __op: 'BitAnd', value };
}
function bitOr(value) {
    return { __op: 'BitOr', value };
}
function bitXor(value) {
    return { __op: 'BitXor', value };
}
function Pointer({ className, id }) {
    return { __type: 'Pointer', className, objectId: id };
}
function addRelation(objects) {
    return { __op: 'AddRelation', objects: castArray__default["default"](objects).map(Pointer) };
}
function removeRelation(objects) {
    return { __op: 'RemoveRelation', objects: castArray__default["default"](objects).map(Pointer) };
}

var operation = /*#__PURE__*/Object.freeze({
  __proto__: null,
  unset: unset,
  increment: increment,
  decrement: decrement,
  add: add,
  addUnique: addUnique,
  remove: remove,
  bitAnd: bitAnd,
  bitOr: bitOr,
  bitXor: bitXor,
  addRelation: addRelation,
  removeRelation: removeRelation
});

const deleteDecoder = () => undefined;
class Pipeline {
    constructor(app) {
        this.app = app;
        this._requests = [];
        this._decoders = [];
        this._ignoreHooks = false;
    }
    _get(className, objectId) {
        this._requests.push({
            method: 'GET',
            path: `/1.1/classes/${className}/${objectId}`,
        });
        this._decoders.push((data) => LCObject.fromJSON(this.app, data, className));
    }
    _update(className, objectId, data, options) {
        this._ignoreHooks || (this._ignoreHooks = (options === null || options === void 0 ? void 0 : options.ignoreBeforeHook) || (options === null || options === void 0 ? void 0 : options.ignoreAfterHook));
        const { method, path, body } = makeUpdateObjectRequest(className, objectId, data, options);
        this._requests.push({ method, path, body });
        this._decoders.push((data) => LCObject.fromJSON(this.app, data, className));
    }
    _delete(className, objectId, options) {
        this._ignoreHooks || (this._ignoreHooks = (options === null || options === void 0 ? void 0 : options.ignoreBeforeHook) || (options === null || options === void 0 ? void 0 : options.ignoreAfterHook));
        const { method, path, body } = makeDeleteObjectRequest(className, objectId, options);
        this._requests.push({ method, path, body });
        this._decoders.push(deleteDecoder);
    }
    add(className, data, options) {
        this._ignoreHooks || (this._ignoreHooks = (options === null || options === void 0 ? void 0 : options.ignoreBeforeHook) || (options === null || options === void 0 ? void 0 : options.ignoreAfterHook));
        const { method, path, body } = makeAddObjectRequest(className, data, options);
        this._requests.push({ method, path, body });
        this._decoders.push((data) => LCObject.fromJSON(this.app, data, className));
        return this;
    }
    get(arg1, objectId) {
        if (typeof arg1 === 'string') {
            this._get(arg1, objectId);
        }
        else {
            this._get(arg1.className, arg1.id);
        }
        return this;
    }
    update(arg1, arg2, arg3, options) {
        if (typeof arg1 === 'string') {
            if (typeof arg2 !== 'string') {
                throw new TypeError('The objectId must be a string');
            }
            this._update(arg1, arg2, arg3, options);
        }
        else {
            if (typeof arg2 === 'string') {
                throw new TypeError('The data must be an object');
            }
            this._update(arg1.className, arg1.id, arg2, arg3);
        }
        return this;
    }
    delete(arg1, arg2, options) {
        if (typeof arg1 === 'string') {
            if (typeof arg2 !== 'string') {
                throw new TypeError('The objectId must be a string');
            }
            this._delete(arg1, arg2, options);
        }
        else {
            if (typeof arg2 === 'string') {
                throw new TypeError('The options must be an object');
            }
            this._delete(arg1.className, arg1.id, arg2);
        }
        return this;
    }
    commit(options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._requests.length === 0) {
                return { results: [], errors: [] };
            }
            if (this._ignoreHooks) {
                assertCanIgnoreHooks(this.app, options);
            }
            const actionResults = (yield this.app.request({
                method: 'POST',
                path: '/1.1/batch',
                body: {
                    requests: this._requests,
                },
            }, options));
            const results = [];
            const errors = [];
            actionResults.forEach((result, index) => {
                if (result.error) {
                    const { code, error } = result.error;
                    errors.push(new APIError(code, error));
                }
                else {
                    results.push(this._decoders[index](result.success));
                }
            });
            return { results, errors };
        });
    }
}

class Database {
    constructor(app) {
        this.app = app;
        this.cmd = queryCommand;
        this.op = operation;
    }
    query(className, decoder) {
        if (decoder) {
            return new Query(this.app, className, decoder);
        }
        return new Query(this.app, className, LCObject.fromJSON);
    }
    class(name, decoder) {
        if (decoder) {
            return new Class(this.app, name, decoder);
        }
        return new Class(this.app, name, LCObject.fromJSON);
    }
    ACL(data) {
        if (data) {
            return ACL.fromJSON(data);
        }
        return new ACL();
    }
    geoPoint(latitude, longitude) {
        return new GeoPoint(latitude, longitude);
    }
    pipeline() {
        return new Pipeline(this.app);
    }
    encode(data, options) {
        return LCEncode(data, options);
    }
    decode(data) {
        return LCDecode(this.app, data);
    }
    encodeObjectData(data) {
        return encodeObjectData(data);
    }
    decodeObject(data, className) {
        return LCObject.fromJSON(this.app, data, className);
    }
    destroyAll(objects, options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (objects.length === 0) {
                return;
            }
            const idsByClassName = {};
            objects.forEach(({ className, id }) => {
                if (className in idsByClassName) {
                    idsByClassName[className].push(id);
                }
                else {
                    idsByClassName[className] = [id];
                }
            });
            const { body } = makeDeleteObjectRequest('', '', options);
            const requests = Object.entries(idsByClassName).map(([className, ids]) => ({
                method: 'DELETE',
                path: `/1.1/classes/${className}/${ids.join(',')}`,
                body,
            }));
            const results = (yield this.app.request({
                method: 'POST',
                path: '/1.1/batch',
                body: { requests },
            }, options));
            const errorResults = results.filter((r) => r.error);
            if (errorResults.length) {
                const apiErrors = errorResults.map(({ error }) => new APIError(error.code, error.error));
                apiErrors[0].errors = apiErrors;
                throw apiErrors[0];
            }
        });
    }
}

function mustGetSyncStorage() {
    const storage = mustGetAdapter('storage');
    if (storage.async) {
        throw new Error('当前平台提供了异步的数据存储功能，请使用异步方法执行该操作');
    }
    return storage;
}
class LocalStorage {
    set(key, value) {
        mustGetSyncStorage().setItem(key, value);
        log.trace('localStorage:set', { key, value });
    }
    get(key) {
        const value = mustGetSyncStorage().getItem(key);
        log.trace('localStorage:get', { key, value });
        return value;
    }
    remove(key) {
        mustGetSyncStorage().removeItem(key);
        log.trace('localStorage:remove', { key });
    }
    setAsync(key, value) {
        return __awaiter(this, void 0, void 0, function* () {
            yield mustGetAdapter('storage').setItem(key, value);
            log.trace('localStorage:set', { key, value });
        });
    }
    getAsync(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const value = yield mustGetAdapter('storage').getItem(key);
            log.trace('localStorage:get', { key, value });
            return value;
        });
    }
    removeAsync(key) {
        return __awaiter(this, void 0, void 0, function* () {
            yield mustGetAdapter('storage').removeItem(key);
            log.trace('localStorage:remove', { key });
        });
    }
}
class NamespacedStorage {
    constructor(storage, namespace) {
        this.storage = storage;
        this.namespace = namespace;
    }
    set(key, value) {
        this.storage.set(this.namespace + '/' + key, value);
    }
    get(key) {
        return this.storage.get(this.namespace + '/' + key);
    }
    remove(key) {
        this.storage.remove(this.namespace + '/' + key);
    }
    setAsync(key, value) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.storage.setAsync(this.namespace + '/' + key, value);
        });
    }
    getAsync(key) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.storage.getAsync(this.namespace + '/' + key);
        });
    }
    removeAsync(key) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.storage.removeAsync(this.namespace + '/' + key);
        });
    }
}
const localStorage = new NamespacedStorage(new LocalStorage(), 'LC');

const version = '0.0.41';

let userAgent;
function getUserAgent() {
    if (userAgent) {
        return userAgent;
    }
    userAgent = 'LeanCloud-JS-SDK/' + version;
    const platformInfo = getAdapter('platformInfo');
    if (platformInfo) {
        const { name, version } = platformInfo;
        if (name) {
            userAgent += version ? ` (${name}/${version})` : ` (${name})`;
        }
    }
    return userAgent;
}

class App {
    constructor(config) {
        this.log = {
            trace: (label, data) => {
                log.trace(label, Object.assign({ appId: this.appId }, data));
            },
            info: (label, data) => {
                log.info(label, Object.assign({ appId: this.appId }, data));
            },
            error: (label, data) => {
                log.error(label, Object.assign({ appId: this.appId }, data));
            },
        };
        this.payload = {};
        if (!config) {
            throw new Error('Missing App config');
        }
        this.config = config;
        if (!this.config.appId) {
            throw new Error('The appId must be provided');
        }
        if (!this.config.appKey) {
            throw new Error('The appKey must be provided');
        }
        if (!this.config.serverURL) {
            if (isCNApp(this)) {
                throw new Error('The serverURL must be provided for CN App');
            }
            this._router = new AppRouter(this);
        }
        if (this.config.production === undefined) {
            this.config.production = true;
        }
        this.localStorage = new NamespacedStorage(localStorage, this.config.appId);
    }
    get appId() {
        return this.config.appId;
    }
    get appKey() {
        return this.config.appKey;
    }
    get serverURL() {
        return this.config.serverURL;
    }
    database() {
        return new Database(this);
    }
    request(request$1, options = {}) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            request$1 = clone__default["default"](request$1);
            options = clone__default["default"](options);
            yield Promise.all(App.hooks.beforeInvokeAPI.map((h) => h(this, request$1, options)));
            const useMasterKey = (_a = options === null || options === void 0 ? void 0 : options.useMasterKey) !== null && _a !== void 0 ? _a : this.config.useMasterKey;
            if (useMasterKey && !this.config.masterKey) {
                throw new Error('The useMasterKey option is on，but masterKey is not set');
            }
            const url = this.serverURL || (yield this._router.getServiceURL(request$1.service || 'api'));
            const { status, body } = yield request(Object.assign(Object.assign({}, request$1), { url: trimEnd__default["default"](url, '/ ') + '/' + trimStart__default["default"](request$1.path, '/ '), header: Object.assign(Object.assign({ 'X-LC-Prod': this.config.production ? undefined : '0' }, request$1.header), { 'Content-Type': 'application/json', 'X-LC-UA': getUserAgent(), 'X-LC-Id': this.appId, 'X-LC-Key': useMasterKey ? this.config.masterKey + ',master' : this.appKey, 'X-LC-Session': options === null || options === void 0 ? void 0 : options.sessionToken, 'X-LC-Hook-Key': this.config.hookKey }) }), options);
            if (status >= 400) {
                const { code, error } = body;
                if (code && error) {
                    throw new APIError(code, error);
                }
                throw new Error(JSON.stringify(body));
            }
            return body;
        });
    }
    static beforeInvokeAPI(h) {
        App.hooks.beforeInvokeAPI.push(h);
    }
}
App.hooks = {
    beforeInvokeAPI: [],
};

use({
    name: 'core',
    components: {
        App,
        Database,
        Query,
        LCObject,
    },
});
function init(config) {
    return new App(config);
}

exports.ACL = ACL;
exports.App = App;
exports.Class = Class;
exports.Database = Database;
exports.GeoPoint = GeoPoint;
exports.LCObject = LCObject;
exports.LCObjectReference = LCObjectReference;
exports.Query = Query;
exports.Runtime = Runtime;
exports.encode = LCEncode;
exports.init = init;
exports.isLCObject = isLCObject;
exports.isLCObjectRef = isLCObjectRef;
exports.makeAddObjectRequest = makeAddObjectRequest;
exports.operation = operation;
exports.queryCommand = queryCommand;
exports.setAdapters = setAdapters;
exports.use = use;
exports.version = version;
